module.exports = __webpack_public_path__ + "static/crt-00-hero-9f434e2ca7f2f6d7b8c601236c70837b.jpg";